import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { DialogComponent } from 'src/app/components';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/_services';
import { LxmAppModule, UserAction } from 'src/app/enum';

@Component({
  selector: "quota-restricted-dialog",
  host: { class: "dialog lexi-dialog" },
  templateUrl: "./quota-restricted.dialog.html",
  styleUrls: ["./quota-restricted.dialog.scss"],
})
export class QuotaRestrictedDialogComponent implements AfterViewInit {
  @ViewChild("dialog", { static: true, read: DialogComponent })
  private _dialog: DialogComponent;

  constructor(
    public dialogRef: MatDialogRef<QuotaRestrictedDialogComponent>,
    private _authService: AuthenticationService
  ) { }

  public ngAfterViewInit(): void { }

  public get canChangeSubscription() {
    return this._authService.hasRight([UserAction.ManageSettings]) && this._authService.hasModule(LxmAppModule.SellerPimExtensions);
  }

  public closeDialog() {
    this.dialogRef.close();
  }
}
